import { TooltipedIconComponent } from 'commons/components';
import { useTranslation } from 'core/i18n/i18n';
import { useNavigate } from 'react-router-dom';
import { EapSettings } from 'modules/settings/pods/settings-devices/settings-devices-menu.model';
import { EapSettingsRowOptionsStyled } from './eap-settings-row-options.style';

interface EapSettingsRowOptionsProps {
    eapSetting: EapSettings;
    onDelete: (eapSettings: EapSettings[]) => void;
}

export const EapSettingsRowOptions = ({ eapSetting, onDelete }: EapSettingsRowOptionsProps) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleOnEdit = (ev: React.MouseEvent) => {
        ev.stopPropagation();
        navigate(eapSetting.id);
    };

    const handleOnDelete = (ev: React.MouseEvent) => {
        ev.stopPropagation();
        onDelete([eapSetting]);
    };

    return (
        <EapSettingsRowOptionsStyled>
            <TooltipedIconComponent
                dataTestId={`options-menu-${eapSetting.id}-edit`}
                tooltipText={t('settings.devices.eap-settings.eap-config-list.action.edit')}
                onClick={handleOnEdit}
                icon="write"
                family="outlined"
            />
            <TooltipedIconComponent
                dataTestId={`options-menu-${eapSetting.id}-delete`}
                tooltipText={t('settings.devices.eap-settings.eap-config-list.action.delete')}
                onClick={handleOnDelete}
                icon="delete"
            />
        </EapSettingsRowOptionsStyled>
    );
};
